// Add new survey interface
export interface ModelSurvey {
  size_28_35: boolean;
  size_55_60: boolean;
  size_60_65: boolean;
  not_interested: boolean;
  dont_know: boolean;
  uses_band_layer: string;
  interested_early_delivery: string;
}

// Update main order interface to include survey
export interface ModelPotatoseedOrder {
  ordinary: any[];
  additional: any[];
  comment: string;
  kurasdelivery: boolean;
  pickup: boolean;
  sender: string;
  survey?: ModelSurvey;  // Make survey optional to maintain compatibility
}

// Keep existing interfaces unchanged
export interface ModelOrdinary {
  kardal: ModelStarchType;
  kuras: ModelStarchType;
  oleva: ModelStarchType;
}

export interface ModelAdditional {
  kardal: ModelStarchType;
  kuras: ModelStarchType;
  oleva: ModelStarchType;
}

export interface ModelStarchType {
  loose: number;
  large: number;
}

export interface seed {
  priceloose: number;
  pricelarge: number;
  classname: string;
  sku: string;
}

export interface seedList {
  displayname: string;
  type: string;
  year: string;
  classes: [seed];
}

// Update order class to include survey
export class order {
  constructor() {
  }

  newOrder(): ModelPotatoseedOrder {
    let txtOrder = {
      "sender": null,
      "sendername": null,
      "receiver": null,
      "receivername": null,
      "ordinary": [],
      "additional": [],
      "comment": null,
      "kurasdelivery": null,
      "pickup": null,
      "survey": {  // Initialize with default values
        size_28_35: false,
        size_55_60: false,
        size_60_65: false,
        not_interested: false,
        dont_know: false,
        uses_band_layer: '',
        interested_early_delivery: ''
      }
    }
    return txtOrder;
  }
}